export default "__VITE_ASSET__Bw6KE_ZG__"